<template>
  <div class="">
    <b-overlay :show="loading">
      <div class="">

        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Select year, month, and employee(s) to bulk assign shifts using a template or download reports.</span>
                <span class="float-right"></span>
            </h4>
        </div>

        <b-form-row class="">
          <b-col cols="2">
            <b-form-group class="mb-0 pt-1">
              <b-input-group prepend="Year">
                <b-form-select plain v-model="filters.year" :options="year_options" @change="getEmployees(dept_id)"/>
              </b-input-group>
            </b-form-group>
          </b-col>


          <b-col cols="2">
            <b-form-group class="mb-0 pt-1">
              <b-input-group prepend="Month">
                <b-form-select plain v-model="filters.month" :options="$month_options" @change="getEmployees(dept_id)"/>
              </b-input-group>
            </b-form-group>
          </b-col>


          <b-col cols="6">
            <b-dropdown id="dropdown-export" v-b-tooltip.hover.top="'Download monthly template to manually assign monthly shifts.'">
              <template #button-content>
                <b-icon icon="download" class="mr-1"></b-icon>
                Download Template
              </template>

              <b-dropdown-item @click="downloadTemplate(1,employee_ids)">
                Shift Template For Selected Employees
              </b-dropdown-item>
              <b-dropdown-item @click="downloadTemplate(3)">
                Shift Template for All Employees
              </b-dropdown-item>
            </b-dropdown>

            <b-button @click="openModal" variant="secondary" class="custom-secodary-btn" v-b-tooltip.hover.top="'Import monthly template to assign monthly shifts '"><b-icon icon="upload" class="mr-1"></b-icon>Import Template</b-button>

            <b-dropdown id="dropdown-export" v-b-tooltip.hover.top="'Download the roster report for the selected year, month, and employee(s).'">
              <template #button-content><b-icon icon="download" class="mr-1"></b-icon>Download Roster Report</template>

              <b-dropdown-item @click="downloadXlsx(0,employee_ids, 'xlsx')">
                <b-icon icon="file-excel" scale="0.8"></b-icon> Download Excel Report For Selected Employees
              </b-dropdown-item>
              <b-dropdown-item @click="downloadXlsx(1, [], 'xlsx')">
                <b-icon icon="file-excel" scale="0.8"></b-icon> Download Excel Report For All Employees
              </b-dropdown-item>

              <b-dropdown-item @click="downloadXlsx(0,employee_ids, 'pdf')">
                <b-icon icon="file-pdf" scale="0.8"></b-icon> Download Pdf Report For Selected Employees
              </b-dropdown-item>
              <b-dropdown-item @click="downloadXlsx(1, [], 'pdf')">
                <b-icon icon="file-pdf" scale="0.8"></b-icon> Download Pdf Report For All Employees
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-form-row>

        <b-alert variant="danger" class="my-2" show v-for="(error, index) in errors" :key="index">{{error}}</b-alert>
        <div class="row" id="assignment">
        <div class="col-12">
          <div class="employee-data">

            <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                         :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
          </div>
        </div>
      </div>

    </div>
    </b-overlay>

    <b-modal id="bv-modal-import-roster" title="Upload Roster File" hide-footer>
      <div class="modal-body-custom">
        <h5 class="mb-3">Upload Roster File</h5>
        <b-form-file @input="onFileChange" v-model="selectedFile" browse-text="Browse" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="closeModal">Cancel</b-button>
          <b-button variant="primary" :disabled="!selectedFile" @click="importFile">Import</b-button>
        </div>
      </div>
    </b-modal>


  </div>
</template>
<script>
export default {
  data(){
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1..12

    return {
      generating: false,
      loading: false,
      previewUrl: '',
      year_options:[],

      filters: {
        year: now.getFullYear(),
        month: ('0' + (new Date().getMonth() + 1)).slice(-2), // 1..12
      },

      checkbox: 0,
      list_key:0,
      is_action: 0,
      custom_list: [],
      errors: [],
      company_options: [],
      employee_ids: [],
      depertments: [],
      selectedFile: null,
      default_column:[ 'name','employee_code', 'jobposition', 'branch'],
      appended_column: [
        { value: "shift", text: "Today's Shift", type: "text" },
        { value: "roster", text: "Today's Roster", type: "text" },
        { value: "off_day", text: "Off Day", type: "text" },
      ],

      y: currentYear,
      m: ('0' + (new Date().getMonth() + 1)).slice(-2),
    }
  },

  created() {
    this.getLeaveYears();
    this.getEmployees();
  },

  methods: {
    getLeaveYears() {
        axios
        .get(this.$api_url + "/leave-attendance/leave-years/list")
        .then((response) => {
        this.year_options = response.data;
        });
    },
    listReturn(data) {
      if(data.selected.length > 0)
      {
        this.employee_ids = data.selected;
      }
      else
      {
        this.employee_ids = [];
        if(data.employee_id > 0)
        {
          // this.showEmployee(data.employee_id);
        }
      }
    },
    showEmployee(employee_id){
      if(!this.checkNet()) return false;
      let formData = new FormData();
      this.loading = true;
      formData.append('employee_id', employee_id);
      axios.post(this.$api_url+'/employee/setemployee', formData).then((response) => {
        this.loading = false;
        window.location.href = this.$api_url+'/leave-attendance/employee/info';
      }).catch((error) => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },
    getEmployees(dept_id = 0) {
      let url = this.$api_url + '/leave-attendance/employees/list';
      if (dept_id != 0) url += '?department_id=' + dept_id;
      axios.get(url,{
        params:{
          month: this.filters.month,
          year: this.filters.year,
          fields:'offday,roster,shift',
        }
      }).then(response => {
        this.list_key++;
        this.custom_list = response.data.employee_data;
        this.company_options = response.data.options;
      });
    },
    downloadXlsx (type, employee_ids = [], format) {

      let formData = new FormData();
      formData.append('file_format', format);
      formData.append('year', this.filters.year);
      formData.append('month', this.filters.month);

      if(type == 0) {
        if(employee_ids.length == 0) {
          this.$bvToast.toast('Please select employee(s)', {
            title: 'Failed',
            solid: true,
            variant: 'danger',
          });
          return;
        }
        formData.append('employee_ids', JSON.stringify(employee_ids));
      }

      this.loading = true;
      axios.post(this.$api_url + '/leave-attendance/schedule/download', formData, { responseType: 'blob' }).then((response) => {
        this.global_download_file_content(response);

        this.$bvToast.toast('File downloaded successfully.', {
          title: 'Success!',
          variant: 'success',
          solid: true,
        });

        this.loading = false;
      }).catch((error) => {
        this.serverError(error);
        this.loading = false;
      });
    },


    openModal() {
      this.$bvModal.show('bv-modal-import-roster');
      this.selectedFile = null
    },

    closeModal() {
      this.$bvModal.hide('bv-modal-import-roster');
      this.selectedFile = null
    },

    onFileChange(event) {
      this.selectedFile = event;
    },

    importFile() {
      if (!this.selectedFile) return

      let formData = new FormData();
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      formData.append('template', this.selectedFile);
      this.loading = true;
      axios.post(this.$api_url + '/leave-attendance/template/import', formData, config).then(response => {
        if(response.data.errors) {
          this.errors = response.data.errors;
        }
        else {
          this.errors = [];
          this.$bvToast.toast(response.data.message,{
            solid: true,
            title: 'Success',
            variant: 'success'
          });
        }
        this.loading = false;
      }).catch(e => {
        this.serverError(e);
        this.loading = false;
      });

      this.closeModal()
    },

    downloadTemplate(download_type, employee_ids = [], dept_id = 0){

      let formData = new FormData();
      formData.append('year', this.filters.year);
      formData.append('month', this.filters.month);

      if(download_type == 1 && employee_ids.length == 0){
        this.$bvToast.toast('Please select employee(s)', {
          title: 'Failed',
          solid: true,
          variant: 'danger',
        });
        return;
      }

      else if(download_type == 2){
        formData.append('department_id', this.fdata.department_id);
        employee_ids = [];
      }
      else if(download_type == 3){
        employee_ids = [];
      }

      if(employee_ids.length > 0) {
        formData.append('employee_ids', JSON.stringify(employee_ids));
      }

      this.loading = true;
      axios.post('/leave-attendance/download/template', formData,{responseType: 'blob'}).then(response => {
        this.global_download_file_content(response);
        this.loading = false;
      })

    },

    confirmClean(all) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete all roster data?', {
        title: 'Confirm Clean',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes, Clean',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (!confirmed) return;
        axios.get('/leave-attendance/clean', {
          params: {
            all: all,
          }
        }).then(() => {
          this.$bvToast.toast('All roster data has been cleared.', {
            title: 'Success', variant: 'success', solid: true
          });
        }).catch(e => {
          this.$bvToast.toast('Failed to clean data.', {
            title: 'Error', variant: 'danger', solid: true
          });
        });
      });
    }
  }
}
</script>
